module.exports = __webpack_public_path__ + "static/media/favorite-recipes.f9ac80cc.png";